import {
  usePlaceholderImage 
} from "@/hooks/Image/usePlaceholderImage"
import {
  transparentPlaceholder 
} from "@/util/images"

import SimpleImage from "./simpleImage"

const PlaceholderImage = (props) => {
  const {
    alt,
    classes,
    displayPlaceholder,
    height,
    imageHasError,
    imageIsLoaded,
    src = transparentPlaceholder,
    width,
    ...rest
  } = props

  const talonProps = usePlaceholderImage({
    displayPlaceholder,
    imageHasError,
    imageIsLoaded,
  })

  const {
    shouldRenderPlaceholder 
  } = talonProps

  const placeholderClass = shouldRenderPlaceholder
    ? classes.placeholder
    : classes.placeholder_layoutOnly

  const placeholderFullClass = `${classes.image} ${placeholderClass}`

  // Note: Attributes that are allowed to be overridden must appear before the spread of `rest`.
  return (
    <SimpleImage
      loading='eager'
      height={height}
      width={width}
      {...rest}
      alt={alt}
      className={placeholderFullClass}
      src={src}
    />
  )
}

export default PlaceholderImage
